import type { ReactNode } from 'react';

import type { DirectiveTone } from '../../lib/consts';

const TONES: Record<DirectiveTone, { border: string; text: string }> = {
	note: {
		border: 'border-gray-4 dark:border-gray-3',
		text: 'text-gray-3',
	},
	info: {
		border: 'border-gray-4 dark:border-gray-3',
		text: 'text-gray-3',
	},
	tip: {
		border: 'border-green-400',
		text: 'text-green-700 dark:text-green-300',
	},
	warning: {
		border: 'border-red',
		text: 'text-red-active dark:text-red',
	},
};

function Callout({
	tone,
	children,
}: {
	tone: DirectiveTone;
	children: ReactNode;
}) {
	const t = TONES[tone];
	return (
		<div
			className={`mt-4 border-l-2 pl-3 leading-relaxed ${t.border} ${t.text} [&>:first-child]:mt-0 [&>p]:text-current`}
		>
			{children}
		</div>
	);
}

export function NoteDirective({ children }: { children?: ReactNode }) {
	return <Callout tone="note">{children}</Callout>;
}

export function InfoDirective({ children }: { children?: ReactNode }) {
	return <Callout tone="info">{children}</Callout>;
}

export function TipDirective({ children }: { children?: ReactNode }) {
	return <Callout tone="tip">{children}</Callout>;
}

export function WarningDirective({ children }: { children?: ReactNode }) {
	return <Callout tone="warning">{children}</Callout>;
}
